import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { showUserDisplayName } from '../../../../lib/userUtils';
import { formatElapsedTime, getDateAndTime } from '../../../../lib/utils';
import SkeletonLoader from '../../../elements/SkeletonLoader';

const TestExecutionForm = ({ execution, users, elapsedTime, loading }) => {
  return (
    <Container>
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          <Row>
            <Col md={3}>
              <p className="form-label mb-1">Key</p>
              <p>{execution?.key}</p>
            </Col>
            <Col md={3}>
              <p className="form-label mb-1">Environment</p>
              <p>{execution?.environment?.name || 'None'}</p>
            </Col>
            <Col md={3}>
              <p className="form-label mb-1">Iteration</p>
              <p>{execution?.iteration?.name || 'None'}</p>
            </Col>
            <Col md={3}>
              <p className="form-label mb-1">Time Elapsed</p>
              <p>
                {formatElapsedTime(elapsedTime || execution?.actual_time) ||
                  'None'}
              </p>
            </Col>
          </Row>
          <hr />
          <Row className="mb-3">
            <Col md={3}>
              <p className="form-label mb-1">Execution Assigned To</p>
              <p>
                {showUserDisplayName(
                  execution?.executed_by || null,
                  users
                )}
              </p>
            </Col>
            {/* <Col md={3}>
              <p className="form-label mb-1">Assigned To</p>
              <p>
                {showUserDisplayName(
                  execution?.association?.assigned_to || null,
                  users
                )}
              </p>
            </Col> */}
            <Col md={3}>
              <p className="form-label mb-1">Executed On</p>
              <p>{getDateAndTime(execution?.updated_at) || '-'}</p>
            </Col>
            <Col md={3}>
              <p className="form-label mb-1">Created On</p>
              <p>{getDateAndTime(execution?.created_at) || '-'}</p>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default TestExecutionForm;
